import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { ApplicationQueryKeys } from "./keys";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { IApplication } from "../../models/Application/Application";

export default function useApplications() {
  const { get } = useApiHelper();

  const applications = useQuery({
    queryKey: ApplicationQueryKeys.all(),
    queryFn: () =>
      get<IDefaultResponse<IApplication[]>>("/application").then(
        (res) => res.data,
      ),
  });

  return {
    applications,
  };
}
